// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3HiL9","inner":"Footer_inner__1rxfm"};